module.exports = {
    VERSION: '1.2.13', //版本号
    // 测评医生端测试环境
    GLOBAL_API_ROOT: 'https://edu.medkg.cn/', // 后端请求地址
    VERSION_ROOT: 'https://software.medkg.cn/', // 版本请求地址
    GLOBAL_SYSTEM: ['实训学生','教师'], //  实训学生、教师、管理
    // ID 和 SYSTEM_MSG二选一,有ID字段时会向后端发请求获取对应参数
    ID: "", // 用来获取项目信息，如果不需要通过请求获取，则此字段不要填，填下面SYSTEM_MSG字段
    SYSTEM_MSG: {
        name: '中医诊断智能实训系统', // 项目名称
        logo: '/common/sx.png',
        favicon_url: '/common/sx.ico'
    },

    // 项目特殊字段处理
    SETTING: {
        ifDesktop: true, // 是否是桌面端,是的话本地edu.config的配置会覆盖全局配置
        ifVerify: true,
        iFHasDevicePulse: true, // 是否支持设备脉，有才会触发设备脉相关功能
        // 教师端范围
        rangeData: ['舌'],
        // 学生端学习模式按钮配置
        studyRange: ['教材学习', '舌图学习'],
        // 学生端练习模式按钮配置
        practiceRange: ['单项练习'],
        // 单项练习
        danxiangRange: {
            keys: ['舌'],
            舌: {
                name: '舌', // 后端交互
                label: '舌', // 页面显示
                children: ["舌色",
                    "苔色",
                    "胖瘦",
                    "点刺",
                    "裂纹",
                    "齿痕",
                    "厚薄",
                    "腐腻",
                    "剥落"
                ]
            },
            面: {
                name: '面',
                label: '面',
                children: ["面色", "局部特征", "面部光泽", "唇色"]
            },
            目: {
                name: '目',
                label: '目',
                children: ["黑睛颜色",
                    "质地",
                    "坑洞",
                    "辐射状黑线",
                    "同心圆状白线",
                    "黑斑黑点",
                    "代谢环",
                    "肠道环",
                    "环七",
                    // "脉络位置",
                    // "脉络颜色",
                    // "脉络走行",
                    // "特殊眼征",
                ]
            },
            掌: {
                name: '掌',
                label: '掌',
                children: ["掌型",
                    "掌色",
                    "掌纹",
                    "1线",
                    "2线",
                    "3线",
                    "巽宫",
                    "离宫",
                    "坤宫",
                    "震宫",
                    "明堂",
                    "兑宫",
                    "艮宫",
                    "坎宫",
                    "乾宫",
                ]
            },
            脉: {
                name: '脉',
                label: '脉',
                children: ["脉名"]
            },
            耳穴: {
                name: '耳穴',
                label: '耳穴',
                children: ["初级", "中级", "高级"]
            },
            四诊: {
                name: '四诊',
                label: '临床',
                children: [] //四诊的选项是通过接口获取的
            },
        },
        // 综合练习
        zongheRange: {
            keys: ['舌', ],
            舌: {
                name: '舌',
                label: '舌',
            },
            面: {
                name: '面',
                label: '面',
            },
            目: {
                name: '目',
                label: '目',
            },
            掌: {
                name: '掌',
                label: '掌',
            },
            脉: {
                name: '脉',
                label: '脉',
            },
            耳穴: {
                name: '耳穴',
                label: '耳穴',
            },
        },
        // 自采练习
        zicaiRange: {
            keys: ['舌'],
            舌: {
                name: '舌',
                label: '舌',
            },
            面: {
                name: '面',
                label: '面',
            },
            目: {
                name: '目',
                label: '目',
            },
            掌: {
                name: '掌',
                label: '掌',
            },
        },
        // 自采练习摄像头配置
        zicaiCamera: {
            舌: {
                support_img: true, // 是否支持自选图片
                support_take_photos_whitelight: true, // 是否支持拍照
                img_num: 1, // 图片数量
                camera_rotation_angle: "0" // 摄像头旋转角度
            },
            面: {
                support_img: true, // 是否支持自选图片
                support_take_photos_whitelight: true, // 是否支持白光单拍
                img_num: 1, // 支持最大图片数量
                camera_rotation_angle: "0" // 摄像头旋转角度
            },
            目: {
                support_img: true, // 是否支持自选图片
                support_take_photos_whitelight: true, // 是否支持拍照
                img_num: 1, // 支持最大图片数量
                camera_rotation_angle: "0" // 摄像头旋转角度
            },
            掌: {
                support_img: true, // 是否支持自选图片
                support_take_photos_whitelight: true, // 是否支持拍照
                img_num: 1, // 支持最大图片数量
                camera_rotation_angle: "0" // 摄像头旋转角度
            },
        },
        // 资源tab顺序
        ziyuan: ['实训', '病例', '图片', '课件', '视频'],
        // 关联资源顺序
        guanlianziyuan: ['图片', '问答', '视频', '课件'],
        // 教师端需要，配置下面参数,在管理端开教师账号会用到
        sizhen_name: '中医舌面诊智能实训系统', // 四诊系统的项目名称,
        siwei_name: '中医临床思维智能实训系统', // 思维系统的项目名称
        // 教师端首页复制下载地址需要
        exe: {
            教师端: 'https://zydata.oss-cn-shanghai.aliyuncs.com/cy/%E5%AE%89%E8%A3%85%E5%8C%85/%E6%B5%8B%E8%AF%95%E5%8C%85/%E6%95%B0%E6%99%BA%E5%8C%96%E4%B8%AD%E5%8C%BB%E5%AE%9E%E8%AE%AD%E6%95%99%E5%AD%A6%E7%AE%A1%E7%90%86%E5%B9%B3%E5%8F%B0%20Setup%201.1.0.exe',
            四诊学生: 'https://zydata.oss-cn-shanghai.aliyuncs.com/cy/%E5%AE%89%E8%A3%85%E5%8C%85/%E6%B5%8B%E8%AF%95%E5%8C%85/%E4%B8%AD%E5%8C%BB%E8%88%8C%E9%9D%A2%E8%AF%8A%E6%99%BA%E8%83%BD%E5%AE%9E%E8%AE%AD%E7%B3%BB%E7%BB%9F%20Setup%201.1.0.exe',
            思维学生: 'https://zydata.oss-cn-shanghai.aliyuncs.com/cy/%E5%AE%89%E8%A3%85%E5%8C%85/%E6%B5%8B%E8%AF%95%E5%8C%85/%E4%B8%AD%E5%8C%BB%E4%B8%B4%E5%BA%8A%E6%80%9D%E7%BB%B4%E6%99%BA%E8%83%BD%E5%AE%9E%E8%AE%AD%E7%B3%BB%E7%BB%9F%20Setup%201.1.0.exe'
        },
        // 教师端首页的平台介绍
        introduce: '本平台是基于知识图谱技术、大语言模型技术、AI视觉技术，结合医学专业知识和真实临床案例而构建的，旨在为教师和学生带来沉浸式的教学体验，大幅提升课堂示教的便利性、自主学习的趣味性、实训练习的互动性与教学方式的创新性。',


    },
    THEME: {
        login: '教学', // 测评 or 教学
        defaultSize: '大', // 默认字号
        ifCanChangeSize: true, // 是否允许在头部切换字号
        // 文字大小配置,
        bigSize: '30px', //大版30，小版28
        h1Size: '22px', //大版22，小版20
        h2Size: '20px', //大版20，小版18
        h3Size: '18px', //大版18，小版16
        mainSize: '16px', //大版16，小版14
        miniSize: '14px', //大版14，小版12

        primaryColor: '#733F2E', // 主题色
        subPrimaryColor: '#1B5AB2', // 副主题色
        miniPrimaryColor: '#F2E9E6', // 浅主题色
        borderColor: 'rgba(115, 72, 57, 0.3)', // 边框线的颜色
        bgColor: 'rgba(115, 72, 57, 0.1)', // 边框线的颜色
        tableBorderColor: '#F2E9E6', // 表格头部底色
        tableHoverColor: '#edddd8', // 表格头部底色
        scrollbarColor: 'rgba(115, 63, 46, 0.4)', //滚动条颜色
        pageBg: "url('/common/page-bg2.png')", //页面背景底图

        // 白色底的四周阴影配置
        boxShadow: '0 2 px 12 px 0 rgba(0, 0, 0, 0.15)', // 四周阴影
    },
    SYSTEM_NAV: {
        manage_nav: [{
                name: "用户管理",
                activePath: "/main/manage/user",
                path: "/main/manage/user",
                icon: 'iconfont icon-zhanghu'
            },
            {
                name: "资料管理",
                activePath: "/main/manage/information",
                path: "/main/manage/information",
                icon: 'iconfont icon-ziyuan'
            },
        ],
        teacher_nav: [{
                name: "首页",
                activePath: "/main/teacher/home",
                path: "/main/teacher/home",
                icon: 'iconfont icon-shouye'
            },
            {
                name: "教材",
                activePath: "/main/teacher/textbook",
                path: "/main/teacher/textbook-folder",
                icon: 'iconfont icon-jiaocai'
            },
            {
                name: "资源",
                activePath: "/main/teacher/resource",
                path: "/main/teacher/resource-folder",
                icon: 'iconfont icon-ziyuan'
            },
            {
                name: "考试",
                activePath: "/main/teacher/exam",
                path: "/main/teacher/exam-list",
                icon: 'iconfont icon-kaoshi'
            },
            {
                name: "班级",
                activePath: "/main/teacher/class",
                path: "/main/teacher/class-list",
                icon: 'iconfont icon-banji'
            },
        ],
        shixun_nav: [{
                name: "学习模式",
                activePath: "/main/shixun/study",
                path: "/main/shixun/study-folder",
                icon: 'iconfont icon-xuexi'
            },
            {
                name: "练习模式",
                activePath: "/main/shixun/practice",
                path: "/main/shixun/practice-folder",
                icon: 'iconfont icon-jiaocai'
            },
            {
                name: "考试模式",
                activePath: "/main/shixun/exam",
                path: "/main/shixun/exam-folder",
                icon: 'iconfont icon-kaoshi'
            },
        ],
        setting_nav: [{
                name: "数据字典",
                // activePath: "/main/manage/user",
                // path: "/main/manage/user",
            },
            {
                name: "帮助中心",
                activePath: "/main/teacher/help",
                path: "/main/teacher/help",
            },
            {
                name: "系统设置",
                activePath: "/main/teacher/setting",
                path: "/main/teacher/setting",
            }
        ]
    },

    // electron-builder.yml
    ProductName:'zysx',// exe名称
    APP_ID: 'com.jx.www', // 应用的唯一id,确认后不要改动了！不然在更新时候，会被认做为两个应用。这个是在apple那里你申请证书的时候，用生成的那个id就可以，类似这种'com.example.app'
    COPYRIGHT: 'jx', // 版权信息
    // 以下图标从请求获取
    LOGO: './public/common/sx.ico', // logo路径,格式为.ico，大小需要256*256的，否则打包会报错

    // package.json
    PACKAGE_NAME: 'jx', //包名
}